/**
 * @fileoverview ESM mirror of ../crossAppRoute.js.
 *
 * See the CJS source for full documentation. Drift between the two is caught by
 * `tests/unit/esmParity.behaviour.test.js` (behaviour) and `tests/esm/native-import.test.mjs` (names).
 *
 * @module @puffin-core/cross-app-policy/crossAppRoute
 */

import { APP_REGISTRY } from './registry.js';
import { assertSafeReturnUrl } from './buildTargetUrl.js';

const CROSS_APP_ROUTE_SCHEME = 'puffin-app://';

function isRegisteredApp(appKey) {
  return typeof appKey === 'string' && Object.prototype.hasOwnProperty.call(APP_REGISTRY, appKey);
}

function crossAppRoute(appKey, returnPath) {
  if (!isRegisteredApp(appKey)) {
    throw new Error(`crossAppRoute: unknown app key "${appKey}"`);
  }
  assertSafeReturnUrl(returnPath);
  return `${CROSS_APP_ROUTE_SCHEME}${appKey}${returnPath}`;
}

function parseCrossAppRoute(route) {
  if (typeof route !== 'string' || !route.startsWith(CROSS_APP_ROUTE_SCHEME)) return null;
  const rest = route.slice(CROSS_APP_ROUTE_SCHEME.length);
  const slash = rest.indexOf('/');
  if (slash <= 0) return null;
  const targetApp = rest.slice(0, slash);
  const returnPath = rest.slice(slash);
  if (!isRegisteredApp(targetApp)) return null;
  try {
    assertSafeReturnUrl(returnPath);
  } catch {
    return null;
  }
  return { targetApp, returnPath };
}

export { CROSS_APP_ROUTE_SCHEME, crossAppRoute, parseCrossAppRoute };
